module.exports = __webpack_public_path__ + "img/chile.8636f06a.svg";